import React from "react";
import { Box, Flex, Text, Image } from "@chakra-ui/react";
import { FilledButton } from "./Button";
import arrow from "../../data/arrow.json";
import Lottie from "lottie-react";
import AppointButton from "./AppointButton";
import { useColorModeValue } from "../ui/color-mode";

const Steps = ({ steps, buttonText, title, colorText }) => {
  const headingColor = useColorModeValue("#008080", "#66b2b2");

  const titleParts = title.split(colorText);
  return (
    <Box
      data-aos="fade-up"
      textAlign="center"
      p={5}
      my={10}
      className="fade-section"
      data-scroll
      data-scroll-class="fade-in"
    >
      <Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold" pb={12}>
        {titleParts[0]}{" "}
        <Text as="span" color={headingColor}>
          {colorText}
        </Text>{" "}
        {titleParts[1]}
      </Text>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="center"
        alignItems="center"
        mb={8}
        gap={{ base: "10", md: "4" }}
      >
        {steps.map((step, index) => (
          <Flex key={index} alignItems="start">
            <Flex direction="column" align="center" gap={2}>
              <Image src={step.icon} boxSize={28} />
              <Text fontSize="md" fontWeight="semibold" color="gray.500" pt={5}>
                {step.label}
              </Text>
            </Flex>
            {index < steps.length - 1 && (
              <Box display={{ base: "none", md: "block" }}>
                <Lottie
                  animationData={arrow}
                  style={{ width: "auto", height: "120px" }}
                />
              </Box>
            )}
          </Flex>
        ))}
      </Flex>
      <AppointButton text={<FilledButton title={buttonText} />} />
    </Box>
  );
};

export default Steps;
